export const COLOR_BLACK = '#121826';
export const COLOR_WHITE = '#fff';
export const COLOR_GRAY = '#D6DCE5';
export const COLOR_RED = '#c00000';
export const COLOR_LINE = COLOR_GRAY;
export const COLOR_BORDER = COLOR_GRAY;

export const FONT = 'HankenGroteskRegular';
export const FONT_BOLD = 'HankenGroteskBold';

export const FONT_SIZE_SMALL = 8;
export const FONT_SIZE_NORMAL = 10;
export const FONT_SIZE_MEDIUM = 12;
export const FONT_SIZE_LARGE = 14;

export const LINE_WEIGHT = 0.5;

export const SPACE = 0.5;
export const SPACE2 = 2;

export const COL_HEIGHT = 10.5;
export const COL_TEXT_OPTIONS = {
	height: COL_HEIGHT,
	ellipsis: '...'
};
export const COL_HEADER_TEXT_SIZE = FONT_SIZE_SMALL;
export const COL_TEXT_SIZE = 9;
export const COL_TEXT_SIZE_SMALL = FONT_SIZE_SMALL;
export const COL_BORDER_WIDTH = 0.25;

export const MINIMUM_ROWS_PER_PAGE = 3;

export const FOOTER_MARGIN = 50;
